<template>
    <Shell :transition="transition">
        <template #header>
            <div class="pb-2">
                <div class="text-3xl">{{ title }}</div>
                <div v-html="subtitle"></div>
            </div>
        </template>

        <div class="px-4 pb-4 space-y-4 flex-grow overflow-auto">
            <div class="bg-white rounded shadow overflow-hidden">
                <div v-html="message" class="rich-text p-2"></div>
            </div>
        </div>
    </Shell>
</template>

<script>
import Shell from './Shell.vue'
import defaultAppearance from '../Store/AparênciaPadrão'

export default {
    components: { Shell },
    props: ['transition'],
    computed: {
        title() {
            return this.$store.state.aparência.thankYouTitle || defaultAppearance.thankYouTitle
        },

        subtitle() {
            let content = this.$store.state.aparência.thankYouSubtitle || defaultAppearance.thankYouSubtitle
            if (content.html) return content.html
            return content
        },

        message() {
            let content =
                this.$store.state.aparência.thankYouMessageAfterClose || defaultAppearance.thankYouMessageAfterClose

            if (content.html) return content.html
            return content
        },
    },
}
</script>